import 'bootstrap/dist/css/bootstrap.css';
import 'ol/ol.css';

import '../css/fonts.css';
import '../css/header.css';
import './css/services.css';

import tracker from '../js/n4m5/util/tracker.js';
import matomo from '../matomo.js';

import initExamples from '../services/js/examples.js';
initExamples();

tracker(matomo.url, matomo.tracker_id);